export default {
  PRELESSONS_PAGE_SHOW: 'AXXWEB_44',
  PRELESSONSLIST_PAGE_SHOW: 'AXXWEB_45',
  PRELESSONSDETAIL_PAGE_SHOW: 'AXXWEB_46',
  PRELESSONS_MATERIALS_CLICK: 'AXXWEB_47',
  PRELESSONS_BUILDCLASS_CLICK: 'AXXWEB_48',
  PRELESSONS_PREPARATION_CLICK: 'AXXWEB_49',
  PRELESSONS_ATTENDCLASS_CLICK: 'AXXWEB_50',
  PRELESSONS_ADDSTU_CLICK: 'AXXWEB_51',
  PRELESSONS_CONTINUE_CLICK: 'AXXWEB_52',
  BANNER_PAGE_SHOW: 'AXXWEB_59',
  BANNER_GO_CLICK: 'AXXWEB_60',
  PRELESSONS_BANSHU_CLICK: 'AXXWEB_71', // 课堂板书
  PRELESSONS_BANSHU_DOWNLOAD_CLICK: 'AXXWEB_72', // 板书下载
};
